import React from 'react';
import logo from '../containers/assets/img/logo-ufvjm.png';

const Header = (props) => {
    return (
        <nav className="navbar navbar-default fixed-top topo-back" style={{ marginBottom: "0" }} role="navigation">
            <span className="logo-mobile">
                <a href="http://www.ufvjm.edu.br">
                    <img src={logo} alt="ufvjm"/>
                </a>
            </span>
            <h4 className="nav navbar-top-links navbar-left" style={{ lineHeight: "25px" }}>
                <span className="logo">
                    <a href="http://www.ufvjm.edu.br">
                        <img src={logo} width="90" alt="ufvjm"/>
                    </a>                    
                </span>
                <span className="topo d-none d-lg-block d-xl-block">
                    Portal de Sistemas Integrados<br />
                    <small>Universidade Federal dos Vales do Jequitinhonha e Mucuri</small>
                </span>
            </h4>

            <div className="top-menu">
                {/* <a className="" href="https://sistemas.apps-teste.ufvjm.edu.br/">
                    <button className="btn btn-primary btn-group-sm btn-space">Inicio</button>
                </a> */}

                <a className="" href="https://sistemas.ufvjm.edu.br/alterar-senha">
                    <button className="btn btn-primary btn-group-sm btn-space">Alterar senha</button>
                </a>

                <a className="" href="https://sistemas.ufvjm.edu.br/recuperar-senha">
                    <button className="btn btn-primary btn-group-sm btn-space">Recuperar senha</button>
                </a>
            </div>
        </nav>
    );

}

export { Header }